/**
 * Respuestas personales recordadas dentro de una feria (PLAN_FERIAS, fase 2).
 *
 * La comuna, la disponibilidad y los documentos de extranjeros respondidos en
 * una postulación desde la página de una feria se reutilizan en la siguiente
 * vacante de la MISMA feria, para no volver a preguntarlos. Viven solo en este
 * navegador, por cuenta y por feria, y vencen a las 24 horas (una postulación
 * de hace meses no cuenta: la persona pudo cambiarse de comuna). Se borran al
 * cerrar sesión. Fuera de la feria no se usan.
 */
const PREFIX = 'fair_answers:';
const TTL_MS = 24 * 60 * 60 * 1000;
export const FAIR_MEMORY_KEYS = ['comuna', 'disponibilidad', 'doc_carnet_frente', 'doc_carnet_reverso', 'doc_visa'];

const storageKey = (candidateId, fairSlug) => `${PREFIX}${candidateId}:${fairSlug}`;

/** Respuestas vigentes de esa cuenta en esa feria ({} si no hay o vencieron) */
export const readFairAnswers = (candidateId, fairSlug) => {
  if (!candidateId || !fairSlug) return {};
  try {
    const raw = localStorage.getItem(storageKey(candidateId, fairSlug));
    if (!raw) return {};
    const data = JSON.parse(raw);
    if (!data || typeof data.savedAt !== 'number' || Date.now() - data.savedAt > TTL_MS) {
      localStorage.removeItem(storageKey(candidateId, fairSlug));
      return {};
    }
    const answers = {};
    FAIR_MEMORY_KEYS.forEach((key) => {
      const value = data.answers ? data.answers[key] : null;
      if (typeof value === 'string' && value.trim()) answers[key] = value.trim();
    });
    return answers;
  } catch (err) {
    return {};
  }
};

/**
 * Guarda (sumando a lo ya recordado) las respuestas de una postulación exitosa
 * y renueva el plazo de 24 horas.
 */
export const saveFairAnswers = (candidateId, fairSlug, answers) => {
  if (!candidateId || !fairSlug) return;
  try {
    const merged = { ...readFairAnswers(candidateId, fairSlug) };
    FAIR_MEMORY_KEYS.forEach((key) => {
      const value = answers && typeof answers[key] === 'string' ? answers[key].trim() : '';
      if (value) merged[key] = value;
    });
    if (Object.keys(merged).length === 0) return;
    localStorage.setItem(storageKey(candidateId, fairSlug), JSON.stringify({ savedAt: Date.now(), answers: merged }));
  } catch (err) {
    // Sin almacenamiento disponible: se vuelve a preguntar, como fuera de la feria
  }
};

/** Al cerrar sesión: borra lo recordado de todas las ferias en este navegador */
export const clearFairAnswers = () => {
  try {
    const keys = [];
    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i);
      if (key && key.startsWith(PREFIX)) keys.push(key);
    }
    keys.forEach((key) => localStorage.removeItem(key));
  } catch (err) {
    // Sin almacenamiento disponible: no hay nada que borrar
  }
};
